import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Input from '../../../../components/common/Input/index'
import Button from '../../../../components/common/Button/index'

const ForgotPassword = ({ onResetPassword }) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = e => {
    e.preventDefault()
    if (!email) return

    onResetPassword(email).catch(err => {
      setError('Email not found or reset failed. Please try again.')
      console.log(err)
    })
  }

  return (
    <div className="flex justify-center items-center h-[100vh]">
      <div className="bg-white p-8 rounded-md shadow-md w-full max-w-md">
        <h2 className="text-center text-dark text-2xl font-semibold mb-4">Forgot Password?</h2>
        <p>Enter your email to receive a password reset link.</p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label htmlFor="email" className="font-medium text-gray-700">
              Email Address
            </label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="mb-2"
            />
          </div>

          {error && (
            <div className="text-base text-center p-2 rounded-md" role="alert">
              {error}
            </div>
          )}

          <Button variant="primary" type="submit" fullWidth className="mt-2">
            Send Reset Link
          </Button>
        </form>
      </div>
    </div>
  )
}

ForgotPassword.propTypes = {
  onResetPassword: PropTypes.func.isRequired,
}

export default ForgotPassword
